export const INVESTMENT_VEHICLES = {
    EQUITY: { id: 6762, name: 'Equity' },
    VENTURE_DEBT: { id: 6783, name: 'Venture Debt' },
    CONVENTIONAL_DEBT: { id: 6790, name: 'Conventional Debt' },
    GRANT: { id: 6791, name: 'Grant' },
    NON_EQUITY_ASSISTANCE: { id: 6792, name: 'Non-equity Assistance' },
    LINE_OF_CREDIT: { id: 6795, name: 'Line of Credit' },
    BUYOUT: { id: 6824, name: 'Buyout' },
    LEVERAGED_BUYOUT: { id: 6825, name: 'Leveraged Buyout' },
    PE_GROWTH: { id: 6826, name: 'PE Growth' },
    BOLT_ON: { id: 6828, name: 'Bolt-on' },
};
